import { Team__Llamas } from "../teams/Llamas";
import { Team__Pistons } from "../teams/Pistons";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__FlintTropics } from "../teams/FlintTropics";


const Pistons = {
  team: Team__Pistons,
  playingPlayers: [],

  goals: 44,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 33,
  penaltyGoals: 0,
  isWinner: false,
};

const FlintTropics = {
  team: Team__FlintTropics,
  playingPlayers: [],

  goals: 13,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada5 = {
  jornadaPosition: 5,
  matches: [
    {
      team1: Pistons,
      team2: PecanBros,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2026-07-31",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Llamas,
      team2: FlintTropics,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2026-07-31",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
